import { AdministrativeNormModel } from './administrative-rule.model';
import { Frecuency } from './frecuency.model';
import { ApiModel } from './generic-state.model';
import { StudentModel } from './student.model';

export interface StudentAdministrativeRuleModel extends ApiModel {
  [key: string]: unknown;
  administrativeRule?: AdministrativeNormModel | null;
  acknowledgmentReceiptPath?: string;
  automatic_charges: boolean;
  back_personal_identification_document: string;
  backPersonalIdentificationDocument: string;
  front_personal_identification_document: string;
  frontPersonalIdentificationDocument: string;
  opportunityStateReasonId: number;
  guardian_id: string;
  payment_method_id?: string;
  privacyUrl?: string;
  status: string;
  student: StudentModel;
  studentCycleId: string;
  guardianName: string;
  school_id: string;
  schoolId: string;
  frequencies?: Frecuency[];
  privacy_policy: boolean;
}

export interface PendingAdministrativeRuleModel extends ApiModel {
  addendum: AdministrativeRuleAddendum[];
  administrativeRuleAddendumUrl: string;
  administrativeRuleAddendumId: string;
  id: string;
  schoolId: string;
  studentId: string;
  academicYearId: string;
  cycleId: string;
  enrollmentNumber: string;
  school: string;
  cycle: string;
  grade: string;
  studentAdminRuleStatus?: string;
  studentAdminRuleId: string;
  fullName: string;
  name: string;
  lastName: string;
  secondLastName: string;
}

export interface StudentAdministrativeRulesPayload {
  backPersonalIdentificationDocument: string;
  backPersonalDocumentType: string;
  children: ChildAdministrativeRulesPayload[];
  docOwner: boolean;
  frontPersonalIdentificationDocument: string;
  frontPersonalDocumentType: string;
  mainGuardianName: '';
  isNoSickness: boolean;
  documentType: string;
}

export interface ChildAdministrativeRulesPayload {
  acceptPrivacyPolicy: string;
  agree: boolean;
  imageAcknowledgment: boolean;
  dofAcknowledgment: boolean;
  educationalAuthorizationLetter: boolean;
  automaticCharges: boolean;
  backPersonalIdentificationDocument: string;
  frequency: string;
  frontPersonalIdentificationDocument: string;
  isNoSickness: boolean;
  mainGuardianName: '';
  documentType: string;
  paymentMethodId: string;
  studentId: string;
  studentCycleId: string;
  studentName: string;
  schoolId: string;
  comprehensiveTrainingActivitiesLetter: boolean;
  educationalAuthorizationLetterAcknowledgment: boolean;
}

export enum AdministrativeRulesAcknowledgmentDocuments {
  authorizationIntegralFormationActivities = 'authorization_integral_formation_activities',
  imageConsent = 'image_consent',
  privacy = 'privacy',
  generalServices = 'general_services',
  acknowledgment = 'acknowledgment',
}

export interface AdministrativeRuleAddendum {
  administrativeRuleAddendumId: string;
  administrativeRuleAddendumDescription: string;
  administrativeRuleAddendumUrl: string;
  saraId?: string;
  description?: string;
}

export interface StudentAdministrativeRuleAddendum {
  administrativeRuleAddendum: AdministrativeRuleAddendum;
  url: string;
}
